import { normalizeDateValue } from 'utils/date';
import { NORMALIZE_NUMBER } from 'utils/number';

import { CellControllerKind } from './config';
import { TableControllersEntity, TableControllersEntityApi } from './entity';

export const normalizeControllerEntity = (
  raw: TableControllersEntityApi
): TableControllersEntity => {
  switch (raw.controller_kind) {
    case CellControllerKind.SELECT:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value,
          options: raw.controller.options,
        },
      };
    case CellControllerKind.INPUT_STRING:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value,
        },
      };
    case CellControllerKind.INPUT_NUMBER:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          format: raw.controller.format,
          value: NORMALIZE_NUMBER[raw.controller.format](raw.controller.value),
        },
      };
    case CellControllerKind.INPUT_DATE:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value
            ? normalizeDateValue(raw.controller.value)
            : null,
        },
      };
    case CellControllerKind.SWITCH:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value,
        },
      };
    case CellControllerKind.PROGRESS_BAR:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value,
          maxValue: raw.controller.max_value,
        },
      };
    case CellControllerKind.NAVIGATION:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: {
            payload: raw.controller.value,
            pivot: {
              isActive: raw.controller.pivot.is_active,
            },
            flat: {
              isActive: raw.controller.flat.is_active,
            },
          },
        },
      };
    case CellControllerKind.NUMBER:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          format: raw.controller.format,
          value: NORMALIZE_NUMBER[raw.controller.format](raw.controller.value),
        },
      };
    default:
      return {
        controllerKind: raw.controller_kind,
        controller: {
          value: raw.controller.value,
        },
      };
  }
};
